module.exports = __webpack_public_path__ + "static/img/down_bg_ar.a98262b5.png";